import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApprovalList, EmployeeAssesment, PerformanceDto } from 'src/app/shared/models/appraisal';
import { Context } from 'src/app/shared/models/context';
import { ToastrService } from 'ngx-toastr';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { Message } from 'src/app/shared/models/domain';

@Component({
  selector: 'app-approval-performance',
  templateUrl: './approval-performance.component.html',
  styleUrls: ['./approval-performance.component.scss']
})
export class ApprovalPerformanceComponent implements OnInit {
  @Output() performance = new EventEmitter<{ id: number; remarks: string }>();;
  @Input() employeeAssesment: EmployeeAssesment = {} as EmployeeAssesment;
  @Output() emitWizardIndex = new EventEmitter<number>();
  @Input() isActive: boolean;
  public submitted: boolean = false;
  public performances: PerformanceDto[] = [];
  public performanceForm: FormGroup;
  private modified: boolean = false;
  public performanceId: number;
  public performanceRemarks: string = '';
  public selectedPerformanceId: number | null = null;
  public context!: Context;
  public isAssesmentCompleted: boolean = false;

  constructor(
    private fb: FormBuilder,
    private appraisalService: ApparaisalService,
    private commonService: CommonService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.isAssesmentCompleted = this.commonService.isAssesmentCompleted(this.employeeAssesment.status);
    this.appraisalService.getPerformances().subscribe((performances: PerformanceDto[]) => {
      this.performances = performances;
      // this.getEmployeeAssessment();
      if (this.employeeAssesment.performanceId) {
        this.performanceId = this.employeeAssesment.performanceId;
        this.performanceRemarks = this.employeeAssesment.performanceRemarks || '';
        this.selectedPerformanceId = this.performanceId;
      }
    });
  }

  public upsertPerformance() {
    if (this.isActive) {
      return;
    }
    this.employeeAssesment.performanceId = this.performanceId;
    if (this.employeeAssesment?.performanceId) {
      this.employeeAssesment.status = "LONE_PERFORMANCE";
      this.employeeAssesment.performanceRemarks = this.performanceRemarks;
      this.appraisalService.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            this.commonService.setToastr(200, "Performance saved Successfully");
            this.emitWizardIndex.emit(2);
          } else {
            this.commonService.setToastr(500, response.text);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.commonService.setToastr(500, error?.error?.error || error.error);
        }
      });
    } else {
      this.commonService.setToastr(500, "Please select a performance type.");
    }
  }

  public getEmployeeAssessment(): void {
    if (this.employeeAssesment?.appraisalId && this.employeeAssesment?.appraiseeId) {
      this.appraisalService.getAssessment(this.employeeAssesment.appraisalId, this.employeeAssesment.appraiseeId).subscribe({
        next: (employeeAssessment: EmployeeAssesment) => {
          this.employeeAssesment = employeeAssessment;

          if (employeeAssessment.performanceId) {
            this.performanceId = employeeAssessment.performanceId;
            this.performanceRemarks = employeeAssessment.performanceRemarks || '';
            this.selectedPerformanceId = this.performanceId;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('Failed to load employee assessment', 'Error');
        }
      });
    }
  }

}